export enum pattern {
    asposeMailQuery = "^[A-Za-z0-9? ,_|!#$%&/()=-]+$"
}

export enum key{
    EnableOAuth2ADFS4 = "enableOAuth2ADFS4",
    EnableAuthMethodsImpersonation = "enableAuthMethodsImpersonation"
}

  export enum Environments{
    development = "development",
    test = "test",
    production = "production"
}

export enum Oauth2Flow{
  clientCredencialGrants = "client_credentials",  
  AutorizationCodeGrant = "code"
}

export enum oaut2Properties{
    response_type ="response_type",
    redirect_uri = "redirect_uri",
    client_id = "client_id", 
    client_secret = "client_secret", 
    auth_url = "auth_url", 
    token_url = "token_url", 
    scope = "scope",
    token_access_type = "token_access_type",
    grant_type ="grant_type",   
    tenant_id = "tenant_id", 
    resource_id = "resource_id", 
    tenant_name = "tenant_name",
    url = "url",
    itemNameOrPath = "itemNameOrPath"
  }

  export enum oaut2PropDisplayName{
    response_type ="Response type",
    redirect_uri = "Redirect uri",
    client_id = "Client id", 
    client_secret = "Client secret", 
    auth_url = "Auth url", 
    token_url = "Token url", 
    scope = "Scope",
    token_access_type = "Token access type",
    grant_type ="Grant type",   
    tenant_id = "Tenant id", 
    resource_id = "Resource id", 
    tenant_name = "Tenant name",
    url = "Url",
    itemNameOrPath = "Item name or path",
    listName = "List name",
    folderPath = "Folder Path"
  }

  export enum ignoreProperToRequestCode{
    auth_url ="auth_url", 
    token_url = "token_url", 
    client_secret ="client_secret"
  }

  export enum commons {
    redirect_url = "#/redirect",
    state = "state"
  }

  export enum AuthenticationTypeDefaultRest {
    none = "none"    
  }

  export enum AuthenticationTypeDefaultCustom {
    none = "none",
    oauth2 = "OAuth2 Authentication"
  }

  export enum states{
    successful = "successful",
    fail = "fail"
  }

  export enum services{
    sharepoint = "sharepoint",
    dropbox = "dropbox",
    email = "email"
  }  